export default __webpack_public_path__ + "static/media/hnh6.3f8db62a.png";